import { z } from 'zod';

const EXCLUDE = '--exclude';
// const YAML_SELECT = '--selector';
/** --select, -s */
const SELECT = ['--select', '-s'];
const RESOURCE_TYPES = ['--resource-types', '--resource-type'];

/**
 * Splits a string on every space, as long as its not quoted
 */
export const toArgv = (str: string) => {
  const matches = str.match(/(?:[^\s"]+|"[^"]*")+/g) || [];
  return matches.map((m) => m.replace(/"/g, ''));
};

/**
 * Takes in a selector string or user input that is meant to be passed to dbt CLI.
 * returns the `select`, `exclude`, and `resourceTypes` flags.
 */
export const zParseSelectFlags = z.string().transform((str, ctx) => {
  const argv = toArgv(str);
  const select: string[] = [];
  const exclude: string[] = [];
  const resourceTypes: string[] = [];
  let currentFlag: 'select' | 'exclude' | 'resourceType' = 'select';
  for (let i = 0; i < argv.length; i++) {
    const value = argv[i];
    if (SELECT.includes(value)) {
      currentFlag = 'select';
      select.length = 0;
    } else if (EXCLUDE === value) {
      currentFlag = 'exclude';
      exclude.length = 0;
    } else if (RESOURCE_TYPES.includes(value)) {
      currentFlag = 'resourceType';
    } else if (value.startsWith('-')) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `\`${value}\` not supported. Instead use \`--select\`, \`--exclude\`, or \`--resource-types\``,
      });
      return z.NEVER;
    } else {
      switch (currentFlag) {
        case 'select':
          select.push(value);
          break;
        case 'exclude':
          exclude.push(value);
          break;
        case 'resourceType':
          resourceTypes.push(value);
          break;
      }
    }
  }
  return {
    select: select.join(' '),
    exclude: exclude.join(' ') || undefined,
    resourceTypes,
  };
});
